export const WEB_MAP_ID = 'e1b754ca501a4e9cb86b164e561f4a54';
